import React from "react";
import { Users } from "lucide-react";
import CrudModule from "@/components/CrudModule";
import { EmployeeSyncImport } from "@/components/EmployeeSyncImport";

const DEPTS = ["Usinagem", "Testes", "Pintura", "Instrumentacao", "Montagem", "Qualidade", "Caldeiraria", "Administrativo", "Geral"];

export default function Employees() {
  return (
    <CrudModule
      title="Colaboradores"
      subtitle="Cadastro de funcionários por setor e função"
      icon={Users}
      endpoint="employees"
      exportKey="employees"
      testid="employees"
      headerExtra={<EmployeeSyncImport onDone={() => window.location.reload()} />}
      columns={[
        { key: "name", label: "Nome" },
        { key: "matricula", label: "Matrícula" },
        { key: "role", label: "Função" },
        { key: "department", label: "Setor" },
        { key: "email", label: "E-mail" },
        { key: "admission_date", label: "Admissão" },
      ]}
      fields={[
        { name: "name", label: "Nome completo", type: "text", required: true, full: true },
        { name: "matricula", label: "Matrícula", type: "text" },
        { name: "cpf", label: "CPF", type: "text" },
        { name: "role", label: "Função / Cargo", type: "text" },
        { name: "department", label: "Setor", type: "select", options: DEPTS, default: "Geral" },
        { name: "email", label: "E-mail (avisos de treinamento)", type: "text", full: true },
        { name: "phone", label: "Telefone", type: "text" },
        { name: "admission_date", label: "Data de admissão", type: "date" },
      ]}
    />
  );
}
